import { Grid2 } from "@mui/material";
import { useState } from "react";
import UncontrolledSearchSelect from "../../../components/UncontrolledSearchSelect";
import { generateUUID } from "../../../utilities/helper";
import CapsTableComponent from "../../../components/CapsTableComponent/CapsTableComponent";

const SubjectStatusCaps = () => {
  const [rows, setRows] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [statusData, setStatusData] = useState([
    {
      name: "Completed",
      id: "completed",
    },
    {
      name: "Enrolled",
      id: "enrolled",
    },
  ]);

  const addRow = () => {
    if (selectedStatus !== "") {
      setRows([
        ...rows,
        {
          id: generateUUID(),
          status: statusData?.find((item) => item?.id === selectedStatus)?.name,
          alertLevel: "",
          capLevel: "",
          targetLevel: "",
        },
      ]);
      setSelectedStatus("");
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "20px",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <CapsTableComponent
          isFullScreen={false}
          rows={rows}
          setRows={setRows}
        />
        <div
          style={{
            border: "1px solid lightgrey",
            borderRadius: "8px",
            padding: "10px",
            width: "40%",
          }}
        >
          <p className="page-heading">Add a New Subject Status Cap</p>
          <Grid2
            container
            alignItems="center"
            justifyContent={"space-between"}
            gap={1}
          >
            <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
              <div>
                <p
                  className="labelStyles"
                  style={{
                    marginTop: "-10px",
                  }}
                >
                  Status
                </p>

                <UncontrolledSearchSelect
                  data={statusData}
                  optionLabel="name"
                  optionKey="id"
                  value={selectedStatus}
                  placeholder="Status"
                  onChange={(selectedValue) => {
                    setSelectedStatus(selectedValue);
                  }}
                />
              </div>
            </Grid2>
          </Grid2>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "20px",
            }}
          >
            <button className="create-btn" onClick={addRow}>
              Add Cap
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubjectStatusCaps;
